'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('../../helper/graphicsHelper');
var appTypes = require('../../types/appTypes');

/**
 * LineModeBorder
 * @author mxj
 * @createDate 2016/8/22
 **/

var LineModeBorder = React.createClass({

  render: function () {
    var style = {
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      zIndex: this.props.zIndex || 10
    };
    return (
      <canvas ref="ctx"
              className="component component-line-mode-border"
              style={style}>

      </canvas>
    );
  },

  onPaint : function(){
    this.doPaint();
  },

  componentDidMount: function () {
    this.doPaint();
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_PAINT,this.onPaint)
  },

  componentDidUpdate: function () {
    this.doPaint();
  },

  doPaint: function () {
    var ctx = ReactDOM.findDOMNode(this.refs.ctx);
    var graphics = ctx.getContext('2d');
    var w =  ctx.clientWidth;
    var h = ctx.clientHeight;
    ctx.width = w;
    ctx.height = h;
    graphicsHelper.drawRect(graphics, 0, 0, w, h, this.props);
  }
});

module.exports = LineModeBorder;


// WEBPACK FOOTER //
// ./src/views/common/LineModeBorder.jsx